import React from "react";
import {
	Dialog,
	DialogTitle,
	DialogContent,
	DialogContentText,
	DialogActions,
	TextField,
	MenuItem,
	Button,
} from "@mui/material";
import { formatPhoneNumber } from "../utility/utils";

const NotifyClaimantDialog = ({
	open,
	onClose,
	currentAssignment,
	selectedClaimantIdx,
	onClaimantSelect,
	currentContact,
	onContactChange,
	errors,
	isSubmitting,
	onSubmit,
}) => (
	<Dialog open={open} onClose={onClose}>
		<DialogTitle>Notify Claimants</DialogTitle>
		<DialogContent>
			<form onSubmit={onSubmit}>
				<DialogContentText>
					Select a claimant and update their contact number if needed.
				</DialogContentText>
				<TextField
					select
					label="Select Claimant"
					value={selectedClaimantIdx}
					onChange={onClaimantSelect}
					fullWidth
					margin="dense"
					required
					variant="standard"
					sx={{ mb: 2 }}
				>
					{currentAssignment?.claimants?.map((claimant, idx) => (
						<MenuItem key={idx} value={idx}>
							{claimant.insuredName} (
							{formatPhoneNumber(claimant.insuredContactDetails)})
						</MenuItem>
					))}
				</TextField>
				<TextField
					autoFocus
					required
					margin="dense"
					id="mobileNumber"
					name="mobileNumber"
					label="Mobile Number"
					type="text"
					value={currentContact}
					error={!!errors.mobileNumber}
					helperText={errors.mobileNumber}
					fullWidth
					variant="standard"
					onChange={onContactChange}
				/>
				<DialogActions>
					<Button
						color="error"
						variant="outlined"
						disabled={isSubmitting}
						onClick={onClose}
					>
						Cancel
					</Button>
					<Button
						disabled={isSubmitting}
						variant="contained"
						type="submit"
					>
						Notify
					</Button>
				</DialogActions>
			</form>
		</DialogContent>
	</Dialog>
);

export default NotifyClaimantDialog;
